export default __webpack_public_path__ + "static/media/visa.3a22e8bb.svg";